import {Anchor, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface ShowMetadataToggleProps {
  isExpanded: boolean;
  onToggle: () => void;
}

const useStyles = createStyles(() => ({
  toggle: {
    alignItems: 'center',
    display: 'inline-flex',
    flexShrink: 0,
    gap: 4,
  },
}));

/**
 * Blue link-style toggle for collapsing / expanding the metadata section on data catalog item
 * detail pages (files, datasets). Renders "Show Metadata ▾" or "Hide Metadata ▴" inline next
 * to the item title.
 */
export default function ShowMetadataToggle({isExpanded, onToggle}: ShowMetadataToggleProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <Anchor component="button" type="button" size="md" fw={700} className={classes.toggle} onClick={onToggle}>
      {isExpanded ? 'Hide Metadata' : 'Show Metadata'}
      <BenchlingIcon icon={isExpanded ? 'chevron-up' : 'chevron-down'} />
    </Anchor>
  );
}
